import { render, staticRenderFns } from "./ClvrConfigElementObjectSelect.vue?vue&type=template&id=57fd4c7a"
import script from "./ClvrConfigElementObjectSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClvrConfigElementObjectSelect.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports